import VueHtml2Canvas from 'vue-html2canvas';
import Vue from 'vue';
Vue.use(VueHtml2Canvas);
